<template>
	<div>
		<egranty-section-divider
			text="Projekt"
		/>
		<v-card-text>
			<display-text-component
				label="Numer"
				:value="projectData.agencyProjectCode"
				flex="full-width"/>
			<display-text-component
				label="Suma kontrolna"
				:value="projectData.controlSum"
				flex="full-width"/>
			<display-text-component
				label="Wersja"
				:value="projectData.agencyProjectVersion"
				flex="full-width"/>
			<display-text-component v-if="projectData.sendDate !== null"
				label="Data wysłania"
				:value="projectData.sendDate"
				flex="full-width"/>
			<display-text-component
				label="Nazwa placówki"
				:value="projectData.agencyName"
				flex="full-width"/>
		</v-card-text>
	</div>
</template>

<script>
	import displayTextComponent from "../../offer/components/DisplayTextComponent";
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";

	export default {

		name: "AgencyChecksum",
		components: {
			EgrantySectionDivider,
			displayTextComponent,
		},
		props: {
			projectData: Object,
		},
		data() {
			return {};
		},
	};
</script>

<style scoped>

</style>
